$("body").on("click", ".variant_block, .thumbnail-list__item", function () {
        $(".first_image").hide(), $(".onclick_variant").show();
    }),
    $("body").on("click", ".Size .variant_block", function () {
        $("fieldset").hasClass("Color") ||
            setTimeout(function () {
                $(".thumbnail-list__item").show();
            }, 1);
    }),
    $(".size_collection label").click(function () {
        $(this).parent().find(".size-label").removeClass("active"), $(this).addClass("active");
    });
var def_select_var = $(".Color .variant_block input.unavailable:checked").val();
function slick_handle_wheel_event(i, e, a) {
    if (!a) {
        var t = Math.abs(i.deltaX) > Math.abs(i.deltaY) ? i.deltaX : i.deltaY;
        console.log("wheel scroll ", i.deltaX, i.deltaY, t), t > 0 ? e.slick("slickNext") : e.slick("slickPrev");
    }
}
$(".Color .select_variant_name").text(def_select_var),
    $("body").on("click", ".Color .variant_block", function () {
        var i = $(this).find("input.unavailable").val();
        $(this).parents(".Color").find(".select_variant_name").text(i);
    });
var slick_handle_wheel_event_debounced = debounce(slick_handle_wheel_event, 300, !0);
const slick_2 = $(".slides");
slick_2.slick({ dots: !1, vertical: !0, slidesToShow: 3, infinite: !1, swipe: !1, arrows: !0 });
var slick_2_is_animating = !1;
slick_2.on("afterChange", function (i) {
    console.log("Slide after change " + i), (slick_2_is_animating = !1);
}),
    slick_2.on("beforeChange", function (i) {
        console.log("Slide before change " + i), (slick_2_is_animating = !0);
    }),
    slick_2.on("wheel", function (i) {
        slick_handle_wheel_event_debounced(i.originalEvent, slick_2, slick_2_is_animating);
    }),
    $(document).ready(function () {
        $("ul.tabs").each(function () {
            var i,
                e,
                a = $(this).find("a");
            (e = $((i = a.first().addClass("active")).attr("href"))),
                a.not(":first").each(function () {
                    $($(this).attr("href")).hide();
                }),
                $(this)
                    .find("a")
                    .click(function (a) {
                        return i.removeClass("active"), e.hide(), (i = $(this)), (e = $($(this).attr("href"))), i.addClass("active"), e.show(), !1;
                    });
        });
    }),
    $(".tasti_area").slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: !1,
        infinite: !1,
        adaptiveHeight: !0,
        dots: !1,
        responsive: [
            { breakpoint: 1100, settings: { arrows: !1, dots: !1, adaptiveHeight: !0, slidesToShow: 2 } },
            { breakpoint: 989, settings: { arrows: !1, dots: !1, adaptiveHeight: !0, slidesToShow: 1 } },
        ],
    }),
    $(".open-popup-link").magnificPopup({ type: "inline", midClick: !0 });
